// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IFileState {
  name: string;
  size: number;
  modified?: Date;
}
